import { useMemo, useState } from 'react';
import { ArrowLeft, Search } from 'lucide-react';
import { Input } from './ui/input';
import MealConflictPill from './MealConflictPill';
import { nutritionStateLabel } from '../utils/planningStatus';
import { formatMacroRow } from '../utils/swapStatus';

// Manual-Swap card presentation with a draft-only selection callback. This
// component never imports or invokes the persisted meal-plan swap API.
export default function DraftSwapPicker({ slot, alternatives, loading, onSelect, onClose }) {
  var [query, setQuery] = useState('');
  var rows = useMemo(function () {
    var q = query.trim().toLowerCase();
    return q ? alternatives.filter(function (m) { return (m.meal_name || '').toLowerCase().includes(q); }) : alternatives;
  }, [alternatives, query]);
  return (
    <div className="fixed inset-0 z-50 bg-background overflow-y-auto" data-testid="draft-swap-picker">
      <div className="sticky top-0 z-10 bg-background border-b border-border px-4 pb-4 header-safe-top">
        <div className="max-w-2xl mx-auto flex items-center gap-3">
          <button onClick={onClose} data-testid="draft-swap-close"><ArrowLeft size={20} /></button>
          <div className="flex-1"><h2 className="font-heading font-bold">Swap {slot}</h2><p className="text-xs text-muted-foreground">Choose a replacement for this draft</p></div>
        </div>
        <div className="max-w-2xl mx-auto relative mt-3"><Search className="absolute left-3 top-2.5 text-muted-foreground" size={17} />
          <Input value={query} onChange={function(e) { setQuery(e.target.value); }} placeholder="Search meals..." className="pl-9" />
        </div>
      </div>
      <div className="max-w-2xl mx-auto p-4 grid grid-cols-2 gap-3">
        {loading ? <p className="col-span-2 text-center text-muted-foreground py-10">Loading replacements...</p> : rows.map(function(alt) {
          var cardMeal = Object.assign({}, alt, { name: alt.meal_name });
          return <button key={alt.meal_id} onClick={function() { onSelect(alt); }} className="text-left bg-card border border-border/40 rounded-xl overflow-hidden" data-testid={'swap-option-' + alt.meal_id}>
            <div className="relative h-28 bg-secondary overflow-hidden">
              {alt.image_url && <img src={alt.image_url} alt={alt.meal_name} className="w-full h-full object-cover" />}
              <MealConflictPill meal={cardMeal} testId={'draft-swap-warning-' + alt.meal_id} />
            </div>
            <div className="p-3"><p className="font-heading font-semibold text-sm truncate">{alt.meal_name}</p>
              <p className="text-xs text-muted-foreground">{formatMacroRow(alt)}</p>
              {nutritionStateLabel(alt.nutrition_state) && <span className="inline-block mt-1 text-[11px] px-2 py-0.5 rounded-full bg-secondary">{nutritionStateLabel(alt.nutrition_state)}</span>}
              {alt.pair_keeps_both === true && <span className="inline-block mt-1 ml-1 text-[11px] px-2 py-0.5 rounded-full bg-emerald-500/15 text-emerald-600">Keeps both days in range</span>}
            </div>
          </button>;
        })}
        {!loading && rows.length === 0 && <p className="col-span-2 text-center text-muted-foreground py-10">No alternatives available</p>}
      </div>
    </div>
  );
}
